import { render, staticRenderFns } from "./batteryMalfunction.vue?vue&type=template&id=4719b519&scoped=true"
import script from "./batteryMalfunction.vue?vue&type=script&lang=js"
export * from "./batteryMalfunction.vue?vue&type=script&lang=js"
import style0 from "./batteryMalfunction.vue?vue&type=style&index=0&id=4719b519&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4719b519",
  null
  
)

export default component.exports